import React, { useState } from 'react';
import { Toaster } from '../components/ui/sonner';
import { toast } from 'sonner';
import { restaurantInfo } from '../mock';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Gallery from '../components/Gallery';
import WhyChooseUs from '../components/WhyChooseUs';
import Reviews from '../components/Reviews';
import DeliveryInfo from '../components/DeliveryInfo';
import Newsletter from '../components/Newsletter';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { ReservationModal } from '../components/ReservationModal';
import { OrderModal } from '../components/OrderModal';
import { FullMenuModal } from '../components/FullMenuModal';

const Home = () => {
  const [reservationOpen, setReservationOpen] = useState(false);
  const [orderOpen, setOrderOpen] = useState(false);
  const [fullMenuOpen, setFullMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background text-foreground font-sans">
      <Toaster position="top-center" theme="dark" />
      
      <Header onReservationClick={() => setReservationOpen(true)} />
      
      <main>
        <Hero 
          onReservationClick={() => setReservationOpen(true)}
          onOrderClick={() => setOrderOpen(true)}
          onFullMenuClick={() => setFullMenuOpen(true)}
        />
        <About />
        <DeliveryInfo />
        <Gallery />
        <WhyChooseUs />
        <Reviews />
        <Newsletter />
        <Contact onReservationClick={() => setReservationOpen(true)} />
      </main>

      <Footer />

      <ReservationModal 
        isOpen={reservationOpen}
        onClose={() => setReservationOpen(false)}
      />
      
      <OrderModal
        isOpen={orderOpen}
        onClose={() => setOrderOpen(false)}
      />

      <FullMenuModal
        isOpen={fullMenuOpen}
        onClose={() => setFullMenuOpen(false)}
      />
    </div>
  );
};

export default Home;
